

import { TableBody, TableRow, TableCell, Button, IconButton, Grid } from '@material-ui/core'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause'
import AssignmentIcon from '@mui/icons-material/Assignment'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'

const CallLogsTable = ({ classes, callLogs, playPauseCallRecord, playing, handleCallForm, page, rowsPerPage }) => {
    return (
        <>
            <TableBody>
                {callLogs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                    <Grid key={index}>
                        <TableRow
                            style={{
                                borderBottom: '2px solid Black',
                            }}
                        >
                            <TableCell>
                                <Button
                                    style={{ color: 'white', textTransform: 'none', marginLeft: '4px' }}
                                    onClick={() => item.recording !== "" ? playPauseCallRecord(item.recording, index) : null}
                                    disabled={item.recording === ""}
                                >
                                    {item.recording !== "" ? (
                                        playing === index ? <PauseIcon /> : <PlayArrowIcon />
                                    ) : (
                                        <VolumeOffIcon />
                                    )}
                                </Button>
                                    {/* Srini - 12/11/24 */}
                                <IconButton
                                    onClick={() => handleCallForm(item.call_form)}
                                    disabled={Object.keys(item.call_form).length === 0}
                                >
                                    {Object.keys(item.call_form).length > 0 && (
                                        <AssignmentIcon sx={{ color: "#fff" }} />
                                    )}
                                </IconButton>
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >

                                {item.call_datetime?.split(' ')[0]} <br />
                                {item.call_datetime?.split(' ')[1]?.split('.')[0]}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.agentid} <br /> {item.name}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.duration} <br /> {item.billsec}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.client_number} <br /> {item.call_form?.name}
                            </TableCell>
                            {/* new column - srini - 05/12/24 */}
                            {/* <TableCell align="left" className={classes.rowtext}>
                                {item.call_form && Object.keys(item.call_form).length > 0 ? (
                                    <>
                                        {item.call_form.other ? (
                                            (() => {
                                                const parsedOther = JSON.parse(item.call_form.other)
                                                return (
                                                    <>
                                                        {parsedOther.clientId ? parsedOther.clientId : '-'} <br />
                                                        {parsedOther.custEmail ? parsedOther.custEmail : '-'}
                                                    </>
                                                )
                                            })()
                                        ) : (
                                            '-'
                                        )}
                                    </>
                                ) : (
                                    '-'
                                )}
                            </TableCell> */}
                            {/* Srini - 05/12/24 */}
                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_form?.other?.clientId} <br />
                                {item.call_form?.other?.custEmail} <br />
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_form?.status}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_status === 'Unknown State' ? 'UnAnswered' : item.call_status}
                            </TableCell>
                        </TableRow>
                    </Grid>
                ))}
            </TableBody>
        </>
    )
}

export default CallLogsTable